export default __webpack_public_path__ + "632dc52a98bcc120f1d1f18fb24a346a.png";